/** @jsx isolateComponent */
import { isolateComponent } from '@zapier/style-encapsulation';
import {
  Colors,
  Heading,
  HeadingLevel,
  Link,
  Spacer,
  Text,
  Typography,
} from '@zapier/design-system';

import HelpCenterLinkIcon from '../../../shared/HelpCenterLinkIcon';
import Surface from '../../../shared/Surface';

import PlayIcon from './icons/play.svg';
import InvoiceIcon from './icons/invoice.svg';
import IdeaIcon from './icons/idea.svg';

const Styles = {
  helpLinkTitle: {
    ...Typography.Body4,
  },
  root: {
    display: 'grid',
    gridGap: 10,
  },
  surface: {
    display: 'grid',
    gridGap: 25,
  },
};

const RebrandStyles = {
  positiveFeedbackTitle: {
    ...Typography.PageHeader,
  },
  positiveFeedbackText: {
    ...Typography.Body1,
  },
  helpLink: {
    display: 'grid',
    columnGap: 10,
    gridTemplateColumns: '40px 1fr',
    '&:hover, &:hover .helpLinkTitle': {
      color: Colors.UiPrimaryStrongest,
    },
  },
};

const HELP_CENTER_LINKS = [
  {
    href: 'https://community.zapier.com/p/developer-zone',
    icon: <PlayIcon />,
    rebrandIcon: <HelpCenterLinkIcon name="personGroupFill" size={40} />,
    title: 'Zapier Developers Community',
    text:
      'Technical discussions about building integrations on the Zapier Platform',
  },
  {
    href: 'https://learn.zapier.com/',
    icon: <InvoiceIcon />,
    rebrandIcon: <HelpCenterLinkIcon name="actionBookmarkFill" size={40} />,
    title: 'The Learning Center',
    text: 'Educational resources to make your work easier',
  },
  {
    href: 'https://help.zapier.com/hc/en-us',
    icon: <PlayIcon />,
    rebrandIcon: <HelpCenterLinkIcon name="fileGuideFill" size={40} />,
    title: 'Zapier Help Center',
    text: 'End-user articles regarding using Zapier',
  },
  {
    href: 'https://zapier.com/blog/all-articles/platform-tips/',
    icon: <IdeaIcon />,
    rebrandIcon: <HelpCenterLinkIcon name="navBlogFill" size={40} />,
    title: 'Zapier Blog: Platform tips',
    text: 'Tips and advice for using the Zapier Platform',
  },
];

/**
 * Showed when you click 'Yes, thank you' in the `<Feedback>` component.
 */
const PositiveFeedback = () => {
  return (
    <div css={Styles.root}>
      <Heading css={RebrandStyles.positiveFeedbackTitle}>
        We’re glad that helped
      </Heading>
      <HeadingLevel>
        <p css={RebrandStyles.positiveFeedbackText}>
          Thanks for providing feedback, we’re glad this could help you! You can
          still{' '}
          <Link href="https://docs.zapier.com/platform/home">
            see more solutions
          </Link>{' '}
          if you’d like to or have further questions.
        </p>
        <Spacer height={16} />
        <Surface
          hasShadow={false}
          title="Help Center"
          titleTypography="ParagraphHeader4"
        >
          <div css={Styles.surface}>
            <p>
              From definitions to tutorials, find what you need to get your Zaps
              running.
            </p>
            {HELP_CENTER_LINKS.map(({ href, rebrandIcon, title, text }) => (
              <a css={RebrandStyles.helpLink} href={href} key={href}>
                {rebrandIcon}
                <div>
                  {/* Add custom className so that we can cascade override the color on hover */}
                  <Heading className="helpLinkTitle" css={Styles.helpLinkTitle}>
                    {title}
                  </Heading>
                  <Text>{text}</Text>
                </div>
              </a>
            ))}
          </div>
        </Surface>
      </HeadingLevel>
    </div>
  );
};
export default PositiveFeedback;
